import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalDetail  {
    _originalTypeClassName = "zERP.BO.GeneralJournalDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalDetail.translate = translateService;
}
this.DimensionValues = [];
this.SubLedgerDetails = [];
this.GeneralJournalDetailID = null;
this.Description = null;
this.Debit = null;
this.Credit = null;
this.Balance = null;
this._key = this.GeneralJournalDetailID = 0; 
}

static translate: TranslateService;
_key: any;
private _GeneralJournalDetailID:any;
get GeneralJournalDetailID(): any {
    return this._GeneralJournalDetailID;
  }
set GeneralJournalDetailID(value: any) {
    this._GeneralJournalDetailID = value;
    this._key = value;
  }
Description:any;
Debit:any;
Credit:any;
Balance:any;
GeneralJournal:any;
Account:any;
TemplateRef:any;
DimensionValues:any;
SubLedgerDetails:any;
static setGeneralJournal = ($this, value) => {
var oldValue = $this.GeneralJournal;
$this.GeneralJournal = value;
if (value != null) {
if (oldValue != null) {
Domain.GeneralJournal.removeGeneralJournalDetails(oldValue, $this);
}
Domain.GeneralJournal.addGeneralJournalDetails(value, $this);
}
}
static setAccount = ($this, value) => {
var oldValue = $this.Account;
$this.Account = value;
if (value != null) {
}
}
static setTemplateRef = ($this, value) => {
var oldValue = $this.TemplateRef;
$this.TemplateRef = value;
if (value != null) {
}
}
static setDimensionValues = ($this, items) => {
                if (items == null) items = [];
                if ($this.DimensionValues == null) $this.DimensionValues = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DimensionValues.length > 0) {
                    Domain.GeneralJournalDetail.removeDimensionValues($this, $this.DimensionValues[0]);
                }

                Domain.GeneralJournalDetail.addManyDimensionValues($this, copyItems);
            }
static addManyDimensionValues = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalDetail.addDimensionValues($this, items[i]);
                }
            }
static addDimensionValues = ($this, item) => {
                if ($this.DimensionValues == null) $this.DimensionValues = [];
                if (item == null || $this.DimensionValues.indexOf(item) > -1) return;
                $this.DimensionValues.push(item);
}
static addRangeDimensionValues = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalDetail.addDimensionValues($this, item));
            }
static removeDimensionValues = ($this, item) => {
                if ($this == null || $this.DimensionValues == null || $this.DimensionValues.indexOf(item) === -1) return;
                var _index = $this.DimensionValues.indexOf(item);
                $this.DimensionValues.splice(_index, 1);
}
static clearDimensionValues = ($this) => { $this.DimensionValues = null; }
static setSubLedgerDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubLedgerDetails == null) $this.SubLedgerDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubLedgerDetails.length > 0) {
                    Domain.GeneralJournalDetail.removeSubLedgerDetails($this, $this.SubLedgerDetails[0]);
                }

                Domain.GeneralJournalDetail.addManySubLedgerDetails($this, copyItems);
            }
static addManySubLedgerDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalDetail.addSubLedgerDetails($this, items[i]);
                }
            }
static addSubLedgerDetails = ($this, item) => {
                if ($this.SubLedgerDetails == null) $this.SubLedgerDetails = [];
                if (item == null || $this.SubLedgerDetails.indexOf(item) > -1) return;
                $this.SubLedgerDetails.push(item);
}
static addRangeSubLedgerDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalDetail.addSubLedgerDetails($this, item));
            }
static removeSubLedgerDetails = ($this, item) => {
                if ($this == null || $this.SubLedgerDetails == null || $this.SubLedgerDetails.indexOf(item) === -1) return;
                var _index = $this.SubLedgerDetails.indexOf(item);
                $this.SubLedgerDetails.splice(_index, 1);
}
static clearSubLedgerDetails = ($this) => { $this.SubLedgerDetails = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalDetailID == null || $this.GeneralJournalDetailID == 0;
            }


}